<template>
  <div style="background-color:#ffffff;">
    <div class="header" ref="elememtNav"></div>
    <div class="teacher_header">
      <div class="teacher_border">
        <img :src="teacher.imageUrl" alt />
      </div>

      <span>{{teacher.teacherName}}</span>
    </div>
    <div ref="elementMain" class="main_content">
      <ul class="main">
        <li
          @click="getInfo(teacher.teacherCode,item.courseId)"
          v-for="item in teacherList"
          :key="item.courseId"
          style="position:relative;"
        >
          <div class="main_box">
            <div>
              <img
                v-if="item.hot"
                style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                src="../../../public/images/hot.png"
                alt
              />
              <img
                v-if="item.onlineTime.slice(0,10)==dateFormat(date)&&(!item.hot)"
                style="position:absolute;right:0;width:0.77rem;height:0.75rem;"
                src="../../../public/images/new.png"
                alt
              />
            </div>
            <div class="main_left">
              <img :src="item.imageUrl" alt />
            </div>
            <div class="main_right">
              <p class="video_name">{{item.name}}</p>
              <p class="video_teacher">{{item.teacher}}</p>
              <div class="img_tab">
                <p v-for="(items,index) in item.labelList" :key="index">{{items}}</p>
              </div>
              <p class="video_all">
                已有
                <span>{{item.viewQuantity}}</span>人看过
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { CourseTeacherdetail } from "../../utils/http";
// import emH5Share from "../emH5Share.js";
export default {
  name: "teacherInfo",
  data() {
    return {
      teacher: {},
      teacherList: [],
      date: new Date(),
      miniToken: ""
    };
  },
  watch: {
    $route: "getParams"
  },
  mounted() {
    // emH5.ShareData = {
    //   title: "金牌课程",
    //   desc: "为您精选投资课程",
    //   link: window.location.href,
    //   // imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
    //   imgUrl: location.href.split("#")[0] + "images/wechatlogo.png",
    //   fail: function(res) {
    //     alert(JSON.stringify(res));
    //   }
    // };
    // emH5.Share();
    window.scrollTo(0, 0);
    this.getParams();
    this.getHeight();
    this.miniToken =
      this.$route.query.miniToken || localStorage.getItem("miniToken") || "";
    localStorage.setItem("miniToken", this.miniToken);
  },
  methods: {
    getHeight() {
      let heightNav = this.$refs.elememtNav.offsetHeight;
      let heightWindow = window.innerHeight;
      let heightMain = heightWindow - heightNav;
      this.$refs.elementMain.style.height = heightMain + "px";
    },
    courseTeacherdetail(v) {
      CourseTeacherdetail({
        teacherCode: v
      }).then(res => {
        if (res.data.code == 0) {
          this.teacher = res.data.data;
          this.teacherList = res.data.data.videoCourseList;
        }
      });
    },
    getInfo(v, u) {
      this.$router.push({
        path: "/courseInfo",
        query: {
          // teacheCode: v,
          courseId: u
        }
      });
      // var url =
      //   window.location.href.split("#")[0] + "#" + "/courseInfo?courseId" + u;
      // window.location.href = url;
    },
    getParams() {
      this.teacherCode = this.$route.query.teacherCode;
      this.courseTeacherdetail(this.teacherCode);
    },
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // var hours =
      //   date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      // var minutes =
      //   date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      // var seconds =
      //   date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    }
  }
};
</script>
<style scoped>
.header {
  width: 7.5rem;
  height: 1.56rem;
  background: url("../../../public/images/teacher_bj.png") no-repeat top center;
  background-size: 7.5rem 1.56rem;
}
.teacher_header {
  position: absolute;
  top: 0.63rem;
  left: 0.34rem;
  width: 3rem;
  height: 1.25rem;
  z-index: 1;
}
.teacher_border {
  float: left;
  width: 1.4rem;
  height: 1.25rem;
  border-radius: 50%;
}
.teacher_header img {
  width: 100%;
  height: 100%;
}
.teacher_header span {
  float: right;
  font-size: 0.42rem;
  color: #fff;
  margin-top: 0.2rem;
}
.main {
  width: 7.5rem;
}
.main_content {
  width: 7.5rem;
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.main li {
  width: 7.5rem;
}
.main_box {
  width: 7.07rem;
  margin: 0 auto;
  border-bottom: 1px solid #efefef;
  overflow: hidden;
}
.main_left {
  float: left;
  width: 3.33rem;
  height: 2.1rem;
  padding: 0.25rem 0.06rem;
}
.main_left img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.main_right {
  float: right;
  width: 3.5rem;
}
.video_name {
  line-height: 0.57rem;
  font-size: 0.35rem;
  margin-top: 0.25rem;
  text-align: left;
  color: #333333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.video_teacher {
  line-height: 0.35rem;
  font-size: 0.25rem;
  text-align: left;
  color: #666666;
}
.img_tab {
  width: 3.5rem;
  height: 0.45rem;
  margin: 0.3rem 0;
  overflow: hidden;
}
.img_tab p {
  float: left;
  height: 0.38rem;
  /* line-height: 0.38rem; */
  border: 1px solid #ea5503;
  border-radius: 30px 30px;
  margin: 0 0.13rem 0.2rem 0;
  font-size: 0.2rem;
  color: #ea5503;
  padding: 0 0.1rem;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.video_all {
  text-align: right;
  width: 3.1rem;
  height: 0.42rem;
  line-height: 0.42rem;
  font-size: 0.24rem;
  color: #999999;
  margin-bottom: 0.1rem;
}
</style>
